import { render, staticRenderFns } from "./CategoryFilter.vue?vue&type=template&id=20d53b7e&scoped=true"
import script from "./CategoryFilter.vue?vue&type=script&lang=js"
export * from "./CategoryFilter.vue?vue&type=script&lang=js"
import style0 from "./CategoryFilter.vue?vue&type=style&index=0&id=20d53b7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d53b7e",
  null
  
)

export default component.exports